import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { InvestmentService } from "../service/finzy-flex/investment/investment.service";
import { Keys, StorageService } from "../service/storage.service";

@Injectable()
export class FlexInvestmentAmountResolver implements Resolve<number>{

    private readonly investmentService: InvestmentService;
    private readonly storageService: StorageService

    constructor(investmentService: InvestmentService, storageService: StorageService) {
        this.investmentService = investmentService;
        this.storageService = storageService;
    }

    async resolve(): Promise<number> {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const result = await this.investmentService.getFlexInvestmentAmount(lenderId);
        if (result && result.data && result.data.length) {
            return result.data[0];
        }
        return 0;
    }
}